import { CompanyEntity, COMPANY_TYPES, DefaultBankAccount, ItemInfoType } from "interfaces";

export const getCompanyInfoColumn = (profile: CompanyEntity): Array<ItemInfoType> => {
  const columns: ItemInfoType[] = [
    {
      label: "Название организации",
      text: profile?.companyName,
    },
    {
      label: "ИНН",
      text: profile?.inn,
    },
    {
      label: profile?.type === COMPANY_TYPES.IP ? "ОГРНИП" : "ОГРН",
      text: profile?.companyRegistrationNumber,
    },
    profile?.kpp && {
      label: "КПП",
      text: profile?.kpp,
    },
  ].filter((c) => !!c) as ItemInfoType[];

  return columns;
};

export const getBankInfoColumn = (bankInfo: DefaultBankAccount): Array<ItemInfoType> => {
  const columns: ItemInfoType[] = [
    {
      label: "Банк-получатель",
      text: bankInfo?.bankName,
    },
    {
      label: "БИК",
      text: bankInfo?.bik,
    },
    {
      label: "Кор. счет",
      text: bankInfo?.correspondentAccount,
    },
    {
      label: "Расчетный счет",
      text: bankInfo?.accountNumber,
    },
  ].filter((c) => !!c) as ItemInfoType[];

  return columns;
};
